import * as FormModel from "@/components/features/setup/model";
import type * as FormModelType from "@/components/features/setup/model/type";

import * as Converter from "./converter";
import * as UseCase from "../use-create-hotel";

const initInputModel: FormModelType.SetupFormModel["InputModel"] = Converter.serverModelToInputModelConverter();

export const useInitialized = () => {
	const { inputModel, viewModel, onSetViewModel } = FormModel.useSetupFormModel(initInputModel);

	const { onCreateHotel } = UseCase.useCreateHotel({ inputModel });

	return {
		viewModel,
		onSetViewModel,

		onCreateHotel,
	};
};
